import { ITypedAPITarget } from "network/NetworkStapler";
import { IOptioPayShopAccessResponse, IOptioPaySingleVoucherResponse, IOptioPayVouchersResponse } from "types/optioPay";

export function vouchers(): ITypedAPITarget<IOptioPayVouchersResponse> {
    return {
        url: "/vouchers",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "GET",
        parse: json => json as IOptioPayVouchersResponse
    };
}

export function voucherById(id: string): ITypedAPITarget<IOptioPaySingleVoucherResponse> {
    return {
        url: "/vouchers/" + id,
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "GET",
        parse: json => json as IOptioPaySingleVoucherResponse
    };
}

export function shopAccess(body: {
    firstName: string;
    lastName: string;
}): ITypedAPITarget<IOptioPayShopAccessResponse> {
    return {
        url: "/users/shop-access",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "POST",
        body: {
            "recipientDetails": {
                "firstName": body.firstName,
                "lastName": body.lastName,
            }
        },
        parse: json => json as IOptioPayShopAccessResponse
    };
}




// WEBPACK FOOTER //
// ./src/network/OptioPayAPI.ts